<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue"
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue"

import shield_svg from '@img/guarantee/shield.svg'
import star_svg from '@img/guarantee/star.svg'
import clock_svg from '@img/guarantee/clock.svg'
import money_svg from '@img/guarantee/money.svg'
import delivery_svg from '@img/guarantee/delivery.svg'
import certificate_svg from '@img/guarantee/certificate.svg'

import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue"
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue"
import {useCallbackStore} from "@js/store/CallbackStore.js"
import FaqComponent from "@js/components/Faq/FaqComponent.vue";

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForBuildersPage",
    components: {
        FaqComponent,
        InfoCards,
        Breadcrumbs,
        MobileTopBar,
    },
    data() {
        return {
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'ГОСТ/ТУ и контроль марок стали',
                    description: 'Двутавр, швеллер, арматура A500C, профильные/круглые трубы, лист/профнастил — марочность и прокатку подтверждаем документально.',
                },
                {
                    logo: certificate_svg,
                    title: 'Паспорта качества и прослеживаемость',
                    description: 'Передаём МК/сертификаты, фиксируем партии/плавки в спецификациях и закрывающих — прозрачность поставок для генподрядчика.',
                },
                {
                    logo: clock_svg,
                    title: 'Плановые отгрузки по графику стройки',
                    description: 'При наличии — отгрузка день-в-день. Формируем календарь поставок под этапы: нулевой цикл, каркас, кровля, ОКС.',
                }
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'НДС, ЭДО и возможная отсрочка',
                    description: 'Полный пакет документов, электронный документооборот. Отсрочка — по договору и кредитной оценке.',
                },
                {
                    logo: delivery_svg,
                    title: 'Доставка на стройплощадку',
                    description: 'Длинномеры/манипуляторы, помощь с пропусками и тайм-слотами, аккуратная разгрузка с учётом ППР и ТБ.',
                },
                {
                    logo: star_svg,
                    title: 'Спецусловия для регулярных закупок',
                    description: 'Индивидуальные цены, квоты и фиксация стоимости на согласованный срок под утверждённый график СМР.',
                }
            ],
            faqItems: [
                {
                    question: 'Поставляете по ГОСТ и подтверждаете марку стали?',
                    answer: `<p>Да. Поставки соответствуют <strong>ГОСТ/ТУ</strong>, марочность и прокатку подтверждаем паспортами качества и МК. В закрывающих документах указываем <strong>партии/плавки</strong> для полной прослеживаемости.</p>`
                },
                {
                    question: 'Делаете резку и комплектовку по сметам/ведомостям?',
                    answer: `<p>Да. Выполняем <strong>резку лентой/газом/плазмой</strong> по чертежам и картам раскроя, комплектуем по сметам и спецификациям (Excel/1С). Маркируем места и прикладываем <strong>упаковочные листы</strong> для ускоренного монтажа.</p>`
                },
                {
                    question: 'Как организована доставка на объект и сроки?',
                    answer: `<p>При наличии — отгружаем <strong>в день заказа</strong> по Москве/МО. На площадку завозим длинномерами/манипуляторами, согласуем <strong>тайм-слоты и пропуска</strong>, учитываем ППР и требования ТБ при разгрузке/хранении.</p>`
                },
                {
                    question: 'Какой минимальный объём и можно ли смешивать позиции?',
                    answer: `<p>Ориентир — от <strong>5 тонн</strong>. Смешанные спецификации (арматура, двутавры/швеллеры, трубы, лист/профнастил) — без проблем, комплектуем под проектную ведомость и этапность СМР.</p>`
                },
                {
                    question: 'Есть ли НДС/ЭДО, отсрочка и фиксация цены?',
                    answer: `<p>Работаем с <strong>НДС</strong>, поддерживаем <strong>ЭДО</strong>. Возможна <strong>отсрочка</strong> по договору. По заявке фиксируем цену на <strong>1–3 дня</strong> либо на согласованный срок под график поставок.</p>`
                },
            ],
        }
    },
    methods: {
        openForm() {
            this.callbackStore.showBaseCallbackPopup({
                title: 'Стать нашим партнёром',
                bitrix_title: 'Заявка на партнёрство (девелоперы/застройщики • металлопрокат)',
            })
        }
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    }
})
</script>

<template>
    <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div class="flex items-center justify-center">
                    <div>
                        <Breadcrumbs class="text-white" color="#ffcf33"/>
                        <h1 class="text-2xl md:text-4xl font-bold mb-5 mt-5">
                            B2B-решения для девелоперов и застройщиков
                        </h1>
                        <p class="md:text-xl mb-5 md:max-w-[80%]">
                            Комплексное снабжение жилых и коммерческих объектов: двутавры, швеллеры, арматура A500C, профильные трубы, лист и профнастил. Прямые отгрузки на стройплощадку.
                        </p>
                        <button
                            @click.prevent="openForm"
                            class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseYellow border-2 border-baseYellow bg-baseYellow md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                        >
                            Стать партнёром
                        </button>
                    </div>
                </div>
                <div class="flex items-center justify-center max-md:hidden">
                    <img src="@img/b2b/builders/top-bg.webp"
                         class="max-h-[500px] rounded-full aspect-square object-cover"
                         alt="Металлопрокат для девелоперов и застройщиков"
                         title="Поставки металлопроката на стройплощадки"/>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px] md:mb-20">
        <div class="container pt-10 md:pt-20 mb-5 md:mb-20">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                <!-- Блок 1 -->
                <div
                    class="flex flex-col border rounded-2xl p-5 md:p-7 bg-[url('@img/b2b/builders/block1.webp')] bg-cover shadow-xl">
                    <h2 class="text-white text-2xl md:text-3xl font-bold mb-5">
                        Услуги для девелоперов
                    </h2>

                    <div class="grid grid-cols-2 gap-3 md:gap-5 h-full">
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Резка арматуры, двутавра, швеллера и труб в размер</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Комплектовка по сметам и проектным ведомостям</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Отгрузка со склада день-в-день (при наличии)</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Логистика: длинномеры, манипуляторы, ж/д</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Документы с НДС, ЭДО, возможность отсрочки</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Подбор аналогов по ГОСТ/ТУ и консультации</p>
                        </div>
                    </div>
                </div>

                <!-- Блок 2 -->
                <div
                    class="flex flex-col border rounded-2xl p-5 md:p-7 bg-[url('@img/b2b/builders/block2.webp')] bg-cover bg-bottom shadow-xl">
                    <h2 class="text-white text-2xl md:text-3xl font-bold mb-5">
                        Услуги для застройщиков
                    </h2>

                    <div class="grid grid-cols-2 gap-3 md:gap-5 h-full">
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Маркировка мест и упаковочные листы для монтажа</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>План поставок по этапам: нулевой цикл, каркас, кровля</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Согласование тайм-слотов и пропусков на площадку</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Помощь с разгрузкой, учёт ППР и ТБ</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>НДС/ЭДО, фиксация цены на 1–3 дня</p>
                        </div>
                        <div
                            class="flex flex-col md:items-center justify-center text-white bg-gray-500 bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-70 p-4 rounded-lg md:rounded-2xl font-medium text-sm md:text-base">
                            <p>Смешанные партии: арматура, балки, трубы, лист</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <InfoCards :items_group_1="items_group_1" :items_group_2="items_group_2" class="mb-5 md:mb-20"/>

    <div class="container">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-20">
            <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                <h2 class="text-2xl md:text-3xl font-bold mb-5">
                    Снимаем рутину снабжения на стройке
                </h2>
                <p class="mb-3">
                    Берём на себя подбор по ГОСТ/ТУ, резку и комплектовку под сметы, упаковку и логистику — чтобы график СМР выполнялся без простоев.
                </p>
                <p class="mb-3">
                    Учитываем специфику площадок: окна поставок, пропуска, требования ТБ и правила складирования металлопроката.
                </p>
                <p class="mb-3">
                    Закрываем задачи:
                </p>
                <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                    <li>подбор марок стали и профилей под расчётные нагрузки;</li>
                    <li>резка по картам/чертежам с контролем допусков;</li>
                    <li>комплектовка и маркировка мест для ускорения монтажа;</li>
                    <li>логистика «до ворот»/на площадку, погрузка-разгрузка.</li>
                </ul>
            </div>

            <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                <h2 class="text-2xl md:text-3xl font-bold mb-5">
                    Как начать сотрудничество
                </h2>
                <p class="mb-3">
                    Оставьте заявку — подготовим КП с учётом объёмов, сроков и этапности строительства. Закрепим персонального менеджера и согласуем SLA поставок.
                </p>
                <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                    <li>спецусловия и квоты для регулярных закупок;</li>
                    <li>личный кабинет: онлайн-заказы и статусы отгрузок;</li>
                    <li>полный пакет документов: НДС, ЭДО, возможна отсрочка.</li>
                </ul>
                <button
                    @click.prevent="openForm"
                    class="mt-4 flex justify-center items-center text-white md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                >
                    Оставить заявку
                </button>
            </div>
        </div>
        <FaqComponent
            title="FAQ для девелоперов и застройщиков"
            subtitle="Условия: ГОСТ/ТУ, резка и комплектовка, доставка на площадку, НДС/ЭДО, отсрочка и фиксация цены."
            :items="faqItems"
            schema-id="schema-developers-faq-jsonld"
        />
    </div>
</template>

<style scoped lang="scss">
</style>
